import { CommonModule } from '@angular/common';
import { Component, input, output, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export enum StepType {
  available,
  done,
  locked,
  hasWarrning,
  disabled,
}

export interface WizardStep<TSectionType> {
  icon?: string;
  title: string;
  isActive: boolean;
  stepType: StepType;
  sectionType: TSectionType;
}

@Component({
  selector: 'app-wizard',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './wizard.component.html',
  styleUrl: './wizard.component.scss',
})
export class WizardComponent<TSectionType> {
  protected readonly StepType = StepType;

  getIsActive(_t7: WizardStep<TSectionType>) {
    return _t7.isActive;
  }
  public items = input.required<WizardStep<TSectionType>[]>();
  public prevButtonText = input.required<string>();
  public nextButtonText = input.required<string>();

  public prevButtonEnabled = input.required<boolean>();
  public nextButtonEnabled = input.required<boolean>();

  public prevButtonHasChevron = input<boolean>(true);
  public nextButtonHasChevron = input<boolean>(true);

  public nextButtonContentTpl = input<TemplateRef<unknown> | null>(null);
  public nextButtonTitleKey = input<string | null>(null);

  public stepSelection = output<number>();
  public prevButtonClicked = output<void>();
  public nextButtonClicked = output<void>();

  public showIcons = input<boolean>(true);
  public showFooter = input<boolean>(true);

  getClassForStepButton(step: WizardStep<TSectionType>) {
    const classes: string[] = [];
    if (step.isActive) classes.push('active');
    switch (step.stepType) {
      case StepType.available:
        break;
      case StepType.done:
        classes.push('finihsed');
        break;
      case StepType.locked:
        classes.push('locked');
        break;
      case StepType.hasWarrning:
        classes.push('hasWarrning');
        break;
      case StepType.disabled:
        classes.push('step-optional');
        break;
    }

    return classes.join(' ');
  }

  getClassForIcon(step: WizardStep<TSectionType>) {
    switch (step.stepType) {
      case StepType.available:
        return 'far fa-circle';
      case StepType.done:
        return 'done fas fa-check-circle';
      case StepType.locked:
        return 'fas fa-lock';
      case StepType.hasWarrning:
        return 'fas fa-exclamation-circle';
      case StepType.disabled:
        return 'fas fa-ban';
    }
  }

  onStepSelection($event: MouseEvent, index: number) {
    this.stepSelection.emit(index);
  }
}
